function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st3{fill:currentColor;}\n\t.st4{fill:url(#SVGID_1_);}\n\t.st5{fill:url(#SVGID_2_);}\n\t.st6{fill:url(#SVGID_3_);}\n\t.st7{fill:url(#SVGID_4_);}\n\t.st8{fill:url(#SVGID_5_);}\n\t.st9{fill:url(#SVGID_6_);}\n\t.st10{fill:url(#SVGID_7_);}\n\t");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "m84.6 0h-6.3-11v34.7c2.8 2.9 6.2 4.9 11 5.6v-29.6h6.3c9.8 0 16 7.4 16 16.6 0 9.1-5.2 16.2-19 16.2-12.5 0-18.1-7.2-22.7-15.8-1 1.1-5.1 5.4-5.7 6-0.5 0.6-1 1.1-1.5 1.7-0.5 0.5-0.9 1-1.4 1.5 5.3 9.5 13.2 18.1 31.7 18.1 20.1 0 30-12.3 30-27.5s-10.4-27.5-27.4-27.5z"
});

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_1_",
  x1: 45.416,
  x2: 57.401,
  y1: 9.1122,
  y2: 9.1122,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#39B54A",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#36A945",
  offset: 1
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "m57.4 18.2v-18.2h-12v2.4c5.5 4.1 9 10 12 15.8z"
});

var _ref6 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_2_",
  x1: 63.337,
  x2: 68.724,
  y1: 50.793,
  y2: 50.793,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#39B54A",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#36A945",
  offset: 1
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "m65.3 51.8c0.7 0.3 1.4 0.6 2.2 0.9l1.2-1.8c-0.7-0.3-1.4-0.6-2.1-1-0.6-0.3-1.3-0.7-1.9-1-0.5 0.7-1 1.3-1.4 2 0.7 0.3 1.3 0.6 2 0.9z"
});

var _ref8 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_3_",
  x1: 68.724,
  x2: 72.931,
  y1: 50.368,
  y2: 50.368,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#39B54A",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#36A945",
  offset: 1
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "m72.9 49.9c-0.9-0.4-1.9-0.8-2.8-1.2-0.5 0.8-0.9 1.5-1.4 2.2 1 0.4 1.9 0.8 2.9 1.1 0.5-0.7 0.9-1.4 1.3-2.1z"
});

var _ref10 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_4_",
  x1: 87.85,
  x2: 91.441,
  y1: 50.089,
  y2: 50.089,
  gradientTransform: "matrix(.9918 -.1282 .1282 .9918 -20.22 10.978)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#39B54A",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#36A945",
  offset: 1
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "m76.8 48.5c-0.8-0.2-1.7-0.4-2.5-0.7-0.3 0.7-0.6 1.4-0.9 2 0.9 0.3 1.7 0.5 2.6 0.7 0.3-0.7 0.6-1.3 0.8-2z"
});

var _ref12 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_5_",
  x1: 75.109,
  x2: 78.062,
  y1: 44.377,
  y2: 44.377,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#39B54A",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#36A945",
  offset: 1
}));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "m78 43.3c-0.8-0.1-1.5-0.2-2.2-0.4-0.2 0.8-0.4 1.6-0.7 2.4 0.8 0.2 1.5 0.4 2.3 0.6 0.3-0.9 0.5-1.7 0.6-2.6z"
});

var _ref14 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_6_",
  x2: 63.093,
  y1: 27.505,
  y2: 27.505,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#39B54A",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#36A945",
  offset: 1
}));

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "m61.2 46.5c-0.6-0.5-1.3-1-1.9-1.5 0.5-0.7 1.1-1.4 1.6-2.1-0.6-0.5-1.2-1-1.7-1.5 0.5-0.6 1-1.3 1.6-2-0.6-0.5-1.1-1.1-1.6-1.7 0.6-0.7 1.2-1.3 1.7-2-0.5-0.6-1-1.2-1.4-1.9 0.6-0.7 1.3-1.4 1.9-2-0.4-0.7-0.8-1.3-1.2-2l-1.2-2.2c-6.8-12.4-11.3-27.6-31.5-27.6-15.2 0-27.5 12.3-27.5 27.5s12.3 27.5 27.5 27.5c6.9 0 13.1-2.5 17.9-6.7v6.7h12v-4.5c-7.5-5.6-14-20.7-14.1-21.1-1.5 9.3-8.3 14.1-15.8 14.1-8.8 0-16-7.2-16-16s7.2-16 16-16c13.8 0 16.1 13.5 22.8 25.5 0.1 0.1 0.2 0.3 0.2 0.4 0.3 0.6 0.7 1.2 1.1 1.8 0.4 0.7 0.9 1.3 1.3 2 0.5 0.7 1 1.4 1.6 2.1 0.5-0.5 0.9-1.1 1.4-1.6 0.5 0.6 1.1 1.2 1.7 1.8-0.5 0.6-1 1.2-1.5 1.7 0.5 0.6 1.1 1.1 1.7 1.7 0.6 0.5 1.2 1.1 1.9 1.6 0.6 0.5 1.2 0.9 1.9 1.3 0.5-0.6 1-1.3 1.5-1.9-0.7-0.5-1.3-0.9-1.9-1.4zm-5-12.4c0.4 0.7 0.9 1.3 1.3 1.9-0.6 0.6-1.1 1.3-1.7 1.9-0.5-0.6-0.9-1.3-1.4-1.9 0.7-0.7 1.2-1.3 1.8-1.9-0.5-0.7-0.9-1.5-1.2-2.3 0.6-0.6 1.3-1.4 1.9-2l1.2 2.2c-0.6 0.7-1.2 1.4-1.9 2.1z"
});

var _ref16 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_7_",
  x1: 60.757,
  x2: 75.109,
  y1: 41.343,
  y2: 41.343,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#39B54A",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#36A945",
  offset: 1
}));

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "m72.5 44.4c0.4-0.7 0.7-1.4 1.1-2.1-0.6-0.2-1.2-0.4-1.8-0.7-0.6-0.2-1.1-0.5-1.6-0.8s-1.1-0.6-1.6-1c-0.6-0.4-1.1-0.8-1.6-1.2-0.4 0.5-0.7 0.9-1.1 1.4-0.6-0.4-1.2-0.8-1.8-1.3 0.4-0.5 0.9-1.2 1.2-1.7-0.9-1-1.8-2-2.6-3.1-0.6 0.7-1.2 1.4-1.8 2 0.5 0.6 1 1.1 1.5 1.6-0.5 0.7-1.1 1.4-1.6 2 0.5 0.5 1.1 1 1.6 1.5-0.5 0.7-1 1.3-1.5 2 0.6 0.5 1.2 1 1.9 1.4 0.5-0.7 1-1.3 1.4-2 0.6 0.4 1.2 0.9 1.9 1.3 0.5-0.7 0.9-1.3 1.3-2 0.5 0.3 1 0.7 1.6 1-0.4 0.7-0.9 1.3-1.3 2-0.5-0.3-1.1-0.6-1.6-1-0.5 0.7-0.9 1.4-1.4 2-0.5 0.7-1 1.4-1.6 2.1 0.6 0.4 1.1 0.7 1.7 1 0.5-0.7 1-1.4 1.5-2.2 0.6 0.4 1.2 0.7 1.8 1 0.5-0.7 0.9-1.4 1.4-2.1 0.6 0.3 1.3 0.6 1.9 0.9 0.9 0.4 1.9 0.7 2.8 1.1 0.3-0.7 0.7-1.5 0.9-2.2-0.9-0.3-1.7-0.6-2.6-0.9z"
});

var _ref18 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "252.7 0 252.7 33.9 231.6 0 221 0 220.4 0 220.4 55 232.7 55 232.7 21.2 253.2 55 264 55 264 0"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  className: "st3",
  x: 200.2,
  width: 11.4,
  height: 55
});

var _ref20 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "115.6 55 145.6 55 145.6 44.6 127 44.6 127 32.7 145.6 32.7 145.6 22.3 127 22.3 127 10.5 145.6 10.5 145.6 0 115.6 0"
});

var _ref21 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "195.2 0 182.3 0 172.3 18.2 162.3 0 149.5 0 166.2 27.3 149 55 161.8 55 172.3 36.6 182.7 55 195.7 55 178.4 27.3"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 264 55",
    viewBox: "0 0 264 55",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.2b622f80.svg";
export { ForwardRef as ReactComponent };